export function normalizeSystemUserActionLogs(payload) {
  const candidates = [
    payload?.actionLogs,
    payload?.items,
    payload?.data?.actionLogs,
    payload?.data?.items,
    payload,
  ];

  for (const candidate of candidates) {
    const list = Array.isArray(candidate) ? candidate : [];
    const normalized = list.filter((item) => item && typeof item === 'object');
    if (normalized.length > 0) {
      return normalized;
    }
  }

  return [];
}
